import Util from "../../lib/util.js";
import FSM from "../../lib/fsm.js";

let User = {};

User.fmtName = function(user) {
    if (!user) return;

    let first = user.firstName;
    let last = user.lastName;
    let email = user.emailAddress;

    let STATE = FSM.init()
                    .add("NO_NAME", !first && !last)
                    .add("FULL_NAME", first && last)
                    .add("PARTIAL_NAME", (first && !last) || (last && !first))
                    .determine()

    switch(STATE) {
        case "NO_NAME":
            return email;
        case "FULL_NAME":
            return `${first} ${last}`;
        case "PARTIAL_NAME":
            return `${first || last} (${email})`;
        default:
            throw `Unexpected state '${STATE}' in Project.contributorName()!`;
    }
};

export default User;